var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "h3",
      {
        staticClass: "boss-joboffer-title boss-setting",
        attrs: { "data-test": "title" },
      },
      [_vm._v("\n    " + _vm._s(_vm.title) + "\n  ")]
    ),
    _vm._v(" "),
    _vm.description
      ? _c(
          "p",
          {
            staticClass: "boss-text margin-top-0 margin-bottom-1",
            attrs: { "data-test": "description" },
          },
          [_vm._v("\n    " + _vm._s(_vm.description) + "\n  ")]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }